export default __webpack_public_path__ + "08234ab6d6450788abf3e7c0c9b3ea79.svg";